import { MainActionType } from './model';

const SELECT_APP: MainActionType = 'SELECT_APP';
const TOGGLE_DRAWER: MainActionType = 'TOGGLE_DRAWER';
const SET_ENV_DATA: MainActionType = 'SET_ENV_DATA';
const TOGGLE_HELP_DRAWER: MainActionType = 'TOGGLE_HELP_DRAWER';

export { SELECT_APP, TOGGLE_DRAWER, SET_ENV_DATA, TOGGLE_HELP_DRAWER };
